import { useSelector, type TypedUseSelectorHook } from 'react-redux';

import type { AssistantState } from './reducers/assistant';
import type { PageState } from './types';

/**
 * Volto's store, as far as this add-on reads it.
 *
 * Volto ships no type for its own root state, so `useSelector` hands back
 * `unknown` and every read would need a cast. One declaration of the slices
 * we actually touch is cheaper than a cast per line, and it fails loudly if
 * a slice is renamed rather than silently returning `undefined`.
 */
export interface RootState {
  assistant: AssistantState;
  form: { global?: PageState; ui?: Record<string, unknown> };
  content: { data?: PageState & { '@id'?: string } };
  sidebar: { tab?: number };
  toolbar: { expanded?: boolean };
  schema: { schema?: { title?: string } };
  userSession: { token?: string | null };
  intl: { locale?: string };
  router: { location?: { pathname?: string } };
}

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
